import { cn } from '@/lib/utils';

type LoadingSpinnerProps = {
  withLoadingText?: boolean;
  size?: number;
  label?: string;
  className?: string;
};

export const LoadingSpinner = ({ size = 32, label = 'Loading', className }: LoadingSpinnerProps) => {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <span
        role="status"
        aria-label={label}
        className="inline-block shrink-0 animate-spin rounded-full border-2 border-gray200 border-t-primary motion-reduce:animate-none motion-reduce:opacity-70"
        style={{ width: size, height: size }}
      />
    </div>
  );
};
